import { Dialog } from "primereact/dialog";
import React, { useState } from "react";
import BrokerModal from "../../../../Utils/BrokerModal/BrokerModal";

export default function EditUser() {
  const [open, setOpen] = useState(false);

  const OpenEdit = () => {
    setOpen(true);
  };
  const CloseEdit = () => {
    setOpen(false);
  };

  window.brokerModalOpen = OpenEdit;
  window.brokerModalClose = CloseEdit;

  return (
    <div>
      <Dialog
        visible={open}
        closeOnEscape
        closeIcon
        onHide={CloseEdit}
        id="modal"
        position="center"
        transitionOptions={false}
        focusOnShow={false}
      >
        <BrokerModal user_id={window.user_id} close={CloseEdit} />
      </Dialog>
    </div>
  );
}


